<!--
  A real <header> with exactly one real <h1>. No page in the app has one
  today (refresh_plan.md 3.1.6). Type treatment follows the prototype's
  `.doc__head`: a caps plate-face title with a tracked label-style crumb
  above it, on the chassis surface.
-->
<template>
  <header class="lw-c-page-header">
    <p v-if="breadcrumb" class="lw-c-page-header__crumb">
      {{ breadcrumb }}
    </p>
    <div class="lw-c-page-header__row">
      <div class="lw-c-page-header__heading-group">
        <h1 class="lw-c-page-header__title">
          {{ title }}
        </h1>
        <p v-if="subtitle" class="lw-c-page-header__subtitle">
          {{ subtitle }}
        </p>
        <div v-if="$slots.meta" class="lw-c-page-header__meta">
          <slot name="meta" />
        </div>
      </div>
      <div v-if="$slots.actions" class="lw-c-page-header__actions">
        <slot name="actions" />
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'LwPageHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
    breadcrumb: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/mixins.generated';

.lw-c-page-header {
  background: var(--lw-bg-chassis);
  color: var(--lw-fg-inverse);
  padding: var(--lw-space-5) var(--lw-space-5) var(--lw-space-4);
  // The token file has no border-width scale, same exception as the 1px
  // hairline: this is the doc__head chassis rule from the prototype,
  // carried here in the tokened amber line colour.
  border-bottom: 3px solid var(--lw-line-chassis);
}

.lw-c-page-header__crumb {
  margin: 0;
  font: var(--lw-type-label);
  color: var(--lw-fg-inverse);
  opacity: 0.7;
}

.lw-c-page-header__row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--lw-space-4);
}

// The gap belongs to the crumb: without one, the title sits on the padding.
.lw-c-page-header__crumb + .lw-c-page-header__row {
  margin-top: var(--lw-space-2);
}

.lw-c-page-header__heading-group {
  min-width: 0;
}

.lw-c-page-header__title {
  margin: 0;
  font: var(--lw-type-title);
  color: var(--lw-fg-inverse);
}

.lw-c-page-header__subtitle {
  margin: var(--lw-space-1) 0 0;
  font: var(--lw-type-body-sm);
  color: var(--lw-fg-inverse);
  opacity: 0.85;
}

.lw-c-page-header__meta {
  display: flex;
  align-items: center;
  gap: var(--lw-space-2);
  margin-top: var(--lw-space-2);
}

.lw-c-page-header__actions {
  flex: none;
  display: flex;
  align-items: center;
  gap: var(--lw-space-2);
}
</style>
